import get from 'lodash/get';
import forEach from 'lodash/forEach';
import reduce from 'lodash/reduce';
import sum from 'lodash/sum';
import values from 'lodash/values';
import maxBy from 'lodash/maxBy';
import isEmpty from 'lodash/isEmpty';
import { find, flatMap } from 'lodash/fp';
import { pipe } from 'ramda';
import { getShop } from './reducers';

export function isKioskUser(user) {
  return get(user, 'shop_users.permissions.kiosk.view', false);
}

export const getShopsById = state => state.admin.shops.byId;

export const getUserForShop = (userId, shop) => find(user => user.id === userId)(shop.users);

export const getShopUser = (state, userId) => pipe(
  getShopsById,
  values,
  flatMap(shop => shop.users),
  find(user => user.id === userId)
)(state);

export function findAdminShopUsersFromShop(shop) {
  const permissionCount = {};
  forEach(shop.users, (user) => {
    const shopUsers = user.shop_users;
    const isKiosk = isKioskUser(user);
    if (user.enabled && !isKiosk) {
      permissionCount[user.id] = reduce(shopUsers.permissions,
        (acc, permission) => acc + sum(values(permission))
        , 0);
    } else if (isKiosk) {
      permissionCount[user.id] = -1;
    } else {
      permissionCount[user.id] = 0;
    }
  });
  return maxBy(shop.users, user => permissionCount[user.id]);
}

export function findAdminShopUser(state, shopId) {
  const shop = getShop(state, shopId);
  if (isEmpty(shop)) {
    return {};
  }

  return findAdminShopUsersFromShop(shop);
}
